import { API_BASE_URL } from "../config/api";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EngineerLayout from "../components/EngineerLayout";
import { downloadReportPdf, openReportPdf } from "../utils/reportApi";

export default function PdfReportPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const isEngineerView = location.pathname.startsWith("/my-reports");

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await axios.get(API_BASE_URL + `/api/visits/${id}`);
        setReport(response.data);
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || "Unknown error";
        alert(`Failed to load report: ${errorMsg}`);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [id]);

  const content = loading ? (
    <div className="p-6">Loading report...</div>
  ) : !report ? (
    <div className="p-6">Report not found.</div>
  ) : (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white shadow rounded-lg p-8 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Report PDF</h1>
          <p className="text-sm text-gray-500 mt-1">
            Open or download the latest saved PDF for this report.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-500">Report ID</p>
            <p className="font-semibold">{report.reportId || "-"}</p>
          </div>
          <div>
            <p className="text-gray-500">Complaint ID</p>
            <p className="font-semibold">{report.complaintRefId || report.complaintId || "-"}</p>
          </div>
          <div>
            <p className="text-gray-500">Customer</p>
            <p className="font-semibold">{report.customerName || report.company || "-"}</p>
          </div>
          <div>
            <p className="text-gray-500">Engineer</p>
            <p className="font-semibold">{report.engineer || "-"}</p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => openReportPdf(id)}
            className="px-5 py-3 rounded text-white bg-blue-600 hover:bg-blue-700"
          >
            Open PDF
          </button>

          <button
            onClick={() => downloadReportPdf(id)}
            className="px-5 py-3 rounded text-white bg-green-600 hover:bg-green-700"
          >
            Download PDF
          </button>

          <button
            onClick={() => navigate(isEngineerView ? `/my-reports/${id}` : `/reports/${id}`)}
            className="px-5 py-3 rounded bg-gray-200 hover:bg-gray-300 text-gray-800"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );

  return isEngineerView ? <EngineerLayout>{content}</EngineerLayout> : content;
}


